import React from 'react'
import { useTranslation, Trans } from 'react-i18next'
import { Button, Modal } from 'react-bootstrap'
import { ReactComponent as UserCheck } from 'assets/svg/user-check.svg'
import SVGIcon from 'reusableComponents/SVGIcon'
import { colors, breakpoints } from 'globalStyles'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { sendOTPForUser } from 'api/shipping'
import { getDOMEncodeString } from 'utils/helperFunctions'
import ChangeMobileNumberModal from 'components/ChangeMobileNumberModal'

const StyledLinkButton = styled(Button)`
  padding: 0;
  background: none !important;
  border: none;
  color: ${colors.primary_blue};
  text-decoration: underline;
  cursor: pointer;
  box-shadow: none;
  &:hover,
  &:focus {
    color: ${colors.primary_blue_dark};
    text-decoration: underline;
    background: none;
    box-shadow: none;
  }
`
const StyledVerifyContent = styled.div`
  .form-floating {
    display: inline-block;
    margin: 7px 0;
    width: 295px;
  }
`
const StyledPopUp = styled(Modal)`
  .modal-dialog.modal-dialog-centered {
    justify-content: center;
  }
  .modal-content {
    max-width: 330px;
    @media ${breakpoints.desktop} {
      max-width: 500px;
    }
  }
  .modal-header {
    background-color: ${colors.translucent_light_blue};
    padding: 0px;
    min-height: 78px;
    justify-content: center;
  }
  .modal-body {
    text-align: center;
    padding: 16px 16px 5px 16px;

    > * {
      display: flex; /* or 'grid' */
      flex-direction: column; /* stack children vertically */
      gap: 16px; /* Adjust this value to control spacing */
      padding-bottom: 15px; /* Optional padding around all children */
    }

    /* Remove the last child's bottom margin */
    > *:last-child {
      margin-bottom: 0;
    }
  }
  .modal-footer {
    border-top: none;
    justify-content: center;
    margin: 8px 0px 48px;
    padding: 0px;
  }
  .modal-title {
    font-weight: 600;
    font-size: 20px;
    padding: 15px;
  }
  .icon-padding {
    padding-right: 20px;
    width: 60px;
  }
  .title-text {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .modal-content {
    width: 100%;
  }

  button.receiveCodePrimBtn.btn.btn-primary {
    width: 298px;
    @media ${breakpoints.desktop} {
      width: 452px;
    }
  }
`
const SendOTPModal = ({ show, phoneNumber, showVerificationCodeModal, onClose }) => {
  const { t, i18n } = useTranslation()
  const { language } = i18n
  const [showChangeMobileModal, setShowChangeMobileModal] = React.useState(false)

  const last3DigitsPhoneNumber = phoneNumber.slice(-3)

  const receiveSms = async () => {
    try {
      await sendOTPForUser(phoneNumber, language)
    } catch (error) {
      console.error('sendOTPForUser error')
    } finally {
      showVerificationCodeModal()
    }
  }

  // PURORS1-7297 - Integrate change mobile number functionality
  const changeMobileNumber = () => {
    setShowChangeMobileModal(true)
    if (typeof onClose === 'function') {
      onClose()
    }
  }

  const handleCloseChangeMobile = () => {
    setShowChangeMobileModal(false)
  }

  return (
    <>
      <StyledPopUp show={show} backdrop="static" centered>
        <StyledPopUp.Header>
          <StyledPopUp.Title autoFocus>
            <div className="title-text">
              <img
                className="icon-padding"
                src={getDOMEncodeString(<SVGIcon Icon={UserCheck} color={colors.primary_black} />)}
                alt="icon-img"
                width="45px"
              />
              <div tabIndex="-1">{t('verificationPopup.verification_popup_title')}</div>
            </div>
          </StyledPopUp.Title>
        </StyledPopUp.Header>
        <StyledPopUp.Body>
          <StyledVerifyContent>
            {t('verificationPopup.send_code', {
              phoneNumber: last3DigitsPhoneNumber,
            })}
          </StyledVerifyContent>
        </StyledPopUp.Body>
        <StyledPopUp.Footer>
          <div>
            <Button
              type="submit"
              variant="primary"
              onClick={receiveSms}
              className="receiveCodePrimBtn"
            >
              {t('verificationPopup.receive_code')}
            </Button>
          </div>
          <div style={{ marginTop: '16px' }}>
            <Trans
              t={t}
              i18nKey="verificationPopup.change_mobile_number"
              components={[<StyledLinkButton variant="link" onClick={changeMobileNumber} />]}
            />
          </div>
        </StyledPopUp.Footer>
      </StyledPopUp>
      <ChangeMobileNumberModal
        show={showChangeMobileModal}
        onCancel={handleCloseChangeMobile}
        onSuccess={() => {
          setShowChangeMobileModal(false)
          if (typeof onClose === 'function') onClose()
        }}
      />
    </>
  )
}

SendOTPModal.propTypes = {
  show: PropTypes.bool.isRequired,
  showVerificationCodeModal: PropTypes.func,
  phoneNumber: PropTypes.string.isRequired,
  onClose: PropTypes.func,
}

SendOTPModal.defaultProps = {
  showVerificationCodeModal: null,
  onClose: null,
}

export default SendOTPModal
